module.exports = __webpack_public_path__ + "static/img/advertisement.3e4c535.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advertisement.png
// module id = GQND
// module chunks = 1